import { Box, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import React, { useEffect, useState } from 'react';

import { httpClient } from 'api/httpClient';
import { LoadingSpinner } from 'components/LoadingSpinner';
import { useNotifyError } from 'utils/notifiers/useNotifyError';

const TemplateInfoPreviewButton = ({ onInfoButtonClick, translate }) => (
	<Tooltip title={translate("osfc.buttons.info")} placement="top">
		<IconButton aria-label="Info" size="small" onClick={onInfoButtonClick} >
			<InfoIcon color="secondary"/>
		</IconButton>
	</Tooltip>
);

const TemplateInfoPreviewDialog = ({ documentTemplateType, onInfoDialogClose, translate }) => {
	const notifyError = useNotifyError();

	const [documentTemplateVariablesTranslations, setDocumentTemplateVariablesTranslations] = useState(undefined);
	const [loading, setLoading] = useState(undefined);

	useEffect(() => {
		const fetchVariables = () => {
			setLoading(true);
			httpClient(`/document-templates-variables/${documentTemplateType}`, {method: 'GET'})
				.then(({ json }) => {
					setDocumentTemplateVariablesTranslations(json);
				})
				.catch((error) => {
					notifyError(error);
				})
				.finally(() => {
					setLoading(false);
				});
		};
		fetchVariables();
	}, []);

	return (
		<Dialog open maxWidth="md" onClose={onInfoDialogClose}>
			<DialogTitle>
				{translate("osfc.dialogs.document-templates.info.title")}
			</DialogTitle>
			<DialogContent>
				{!loading && documentTemplateVariablesTranslations !== undefined
				? 
					<React.Fragment>
						<Typography>
							{translate("osfc.dialogs.document-templates.info.description")}
							{" "}
							<span style={{ fontWeight: "bold" }}>
								{"{"}the_variable_name{"}"}
							</span>
						</Typography>
						<Box mt={2}>
							<Table size="small">
								<TableHead>
									<TableRow>
										<TableCell variant='head' style={{ fontWeight: "bold" }}>
											{translate("osfc.dialogs.document-templates.info.header.variable")}
										</TableCell>
										<TableCell variant='head' style={{ fontWeight: "bold" }}>
											{translate("osfc.dialogs.document-templates.info.header.description")}
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{Object.entries(documentTemplateVariablesTranslations)
									.map(([varName, desc], index) => (
										<TableRow key={index}>
											<TableCell variant='body' style={{ fontWeight: "bold" }}>
												{varName}
											</TableCell>
											<TableCell variant='body'>
												{translate(desc)}
											</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</Box>
					</React.Fragment>
				: 
					<LoadingSpinner />
				}
			</DialogContent>
			<DialogActions>
				<Button onClick={onInfoDialogClose} color="primary">
					{translate("ra.action.cancel")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export {
	TemplateInfoPreviewButton,
	TemplateInfoPreviewDialog,
};
